import React from 'react';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TextField from '@mui/material/TextField';

import Cell from '../Cell';

export default ({ mode, trplData, restriction, onCreateVirtualTrplBtn, onVirtualRestrictionTextChange }) => {
  return (
    <Table>
      <TableBody>
        <TableRow>
          <Cell>
            <TextField
              id="value"
              label="value"
              value={trplData ? trplData.val : restriction.value}
              onChange={(e) => onVirtualRestrictionTextChange(e.target.value, mode ? 'val' : 'value', mode)}
              margin="normal"
            />
          </Cell>

          <Cell>
            <TextField
              id="func"
              label="func"
              value={trplData ? trplData.function : restriction.func}
              onChange={(e) => onVirtualRestrictionTextChange(e.target.value, mode ? 'function' : 'func', mode)}
              margin="normal"
            />
          </Cell>

          <Cell>
            <TextField
              id="data"
              label="Data"
              multiline
              rows="2"
              value={JSON.stringify(trplData ? trplData.trpl_data : restriction.data)}
              onChange={(e) => {
                onVirtualRestrictionTextChange(e.target.value, mode ? 'trpl_data' : 'data', mode);
              }}
              margin="normal"
            />
          </Cell>

          <Cell>
            <TextField
              id="render"
              label="Render"
              value={trplData ? trplData.render : restriction.render}
              onChange={(e) => onVirtualRestrictionTextChange(e.target.value, 'render', mode)}
              margin="normal"
            />
          </Cell>

          <Cell>
            <Button variant="contained" size="small" color="primary" onClick={() => onCreateVirtualTrplBtn()}>
              {trplData ? 'Edit' : 'Create'}
            </Button>
          </Cell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
